module.exports = __webpack_public_path__ + "b4804d6801965fb60c73e327591d9121.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ServeInformation/Assets/eatforhealth.png
// module id = 1364
// module chunks = 0